var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getJson && _vm.isMobile === false)?_c('PCMethod',{attrs:{"json":_vm.json}}):(_vm.getJson && _vm.isMobile === true)?_c('MobMethod',{attrs:{"json":_vm.json}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }